import React from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import BaseModal from "../../components/BaseModal";
import BaseButton from "../../components/BaseButton";
import BaseIcon from "../../components/BaseIcon";
import { MODAL_TYPES } from "../../utils/emitter";
import PersonalAccount from "../../store/PersonalAccount";
import { buildShareLink, shareApp } from "../../utils/share";
import "./style.scss";

// Попап ИНСТРУКЦИЯ (правила баллов) — дизайн Figma 11475-48020: интро, как получать
// баллы (✓), на что тратить (★), подсказка (серым), кнопка «Поделиться».
// Открывается по клику ИНСТРУКЦИЯ и по «Подробнее» из поздравления.
export default observer(function PointsInstructionModal() {
  const { t } = useTranslation();
  const earn = t("loyalty.instruction.earn", { returnObjects: true });
  const spend = t("loyalty.instruction.spend", { returnObjects: true });

  const share = async () => {
    await shareApp({
      url: buildShareLink(PersonalAccount.user?.refCode),
      text: t("share.invite_text"),
      sentryTag: "PointsInstruction",
    });
  };

  return (
    <BaseModal
      className="points-instruction-modal"
      eventTypeModal={MODAL_TYPES.POINTS_INSTRUCTION}
      description={
        <div className="points-instruction">
          <p className="points-instruction__intro">
            {t("loyalty.instruction.intro")}
          </p>
          <p className="points-instruction__subtitle">
            {t("loyalty.instruction.earn_title")}
          </p>
          {(Array.isArray(earn) ? earn : []).map((item, i) => (
            <div key={`e${i}`} className="points-instruction__item">
              <BaseIcon
                name="check_purple"
                className="points-instruction__check"
              />
              <span>{item}</span>
            </div>
          ))}
          <p className="points-instruction__subtitle">
            {t("loyalty.instruction.spend_title")}
          </p>
          {(Array.isArray(spend) ? spend : []).map((item, i) => (
            <div key={`s${i}`} className="points-instruction__item">
              <BaseIcon name="star" className="points-instruction__star" />
              <span>{item}</span>
            </div>
          ))}
          <p className="points-instruction__hint">
            {t("loyalty.instruction.hint")}
          </p>
        </div>
      }
    >
      <BaseButton onClick={share} className="points-instruction__share">
        <BaseIcon
          name="share_gradient_white"
          className="points-instruction__share-icon"
        />
        {t("loyalty.instruction.share_btn")}
      </BaseButton>
    </BaseModal>
  );
});
